import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import ShouYe from "../views/shouye/index.vue";

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    redirect: "/index",
    children: [
      {
        path: "/index",
        name: "shouye",
        component: ShouYe,
      },
      {
        path: "/lab",
        name: "实验室",
        component: () => import("../views/shiyanshi/index.vue"),
      },
      {
        path: "/renyuan",
        name: "研究人员",
        component: () => import("../views/renyuan/index.vue"),
      },
      {
        path: "/cg",
        name: "研究成果",
        component: () => import("../views/chengguo/index.vue"),
      },
      {
        path: "/gj",
        name: "国际合作与交流",
        component: () => import("../views/guojihezuo/index.vue"),
      },
      {
        path: "/yg",
        name: "运行管理",
        component: () => import("../views/yunxingguanli/index.vue"),
      },
      {
        path: "/kf",
        name: "开放研究基金",
        component: () => import("../views/kaifangjijin/index.vue"),
      },
      {
        path: "/NewsDetail/:id",
        name: "文章内容",
        component: () => import("../views/shouye/dongtaiNews/NewsDetail.vue"),
      },
      {
        path: "/NewsList",
        name: "新闻列表",
        component: () => import("../views/shouye/dongtaiNews/NewsList.vue"),
      },
      {
        path: "/InfoDetail/:id",
        name: "文章内容",
        component: () => import("../views/shouye/infoGonggao/InfoDetail.vue"),
      },
      {
        path: "/InfoList",
        name: "新闻列表",
        component: () => import("../views/shouye/infoGonggao/InfoList.vue"),
      },
      {
        path: "/ResearchDetail/:id",
        name: "文章内容",
        component: () => import("../views/shouye/researchDongtai/ResearchDetail.vue"),
      },
      {
        path: "/ResearchList",
        name: "新闻列表",
        component: () => import("../views/shouye/researchDongtai/ResearchList.vue"),
      },
      {
        path: "/dn1",
        name: "安康市人民政府市长王浩一行来河海大学调研交流",
        component: () => import("../views/shouye/dongtaiNews/d1.vue"),
      },
      {
        path: "/dn2",
        name: "水利部水循环与水动力系统重点实验室召开第一届学术委员会第一次会议",
        component: () => import("../views/shouye/dongtaiNews/d2.vue"),
      },
      {
        path: "/dn3",
        name: "水利部部署加快推进2023年重大水利工程前期工作",
        component: () => import("../views/shouye/dongtaiNews/d3.vue"),
      },
      {
        path: "/dn4",
        name: "推进智慧水利建设",
        component: () => import("../views/shouye/dongtaiNews/d4.vue"),
      },
      {
        path: "/info1",
        name: "第十一届国际项目管理协会研究大会暨第九届世界水谷论坛",
        component: () => import("../views/shouye/infoGonggao/info1.vue"),
      },
      {
        path: "/info2",
        name: "关于举办“2023年（第十一届）中国水利信息化技术论坛”的通知",
        component: () => import("../views/shouye/infoGonggao/info2.vue"),
      },
      {
        path: "/info3",
        name: "关于举办“2022（第十届）中国水利信息化技术论坛”的通知",
        component: () => import("../views/shouye/infoGonggao/info3.vue"),
      },
      {
        path: "/info4",
        name: "第三届水利水电信息化和智能化发展前沿青年学术论坛(第二号通知)",
        component: () => import("../views/shouye/infoGonggao/info4.vue"),
      },
      {
        path: "/info5",
        name: "关于举办“2021中国水资源高效利用与节水技术论坛”的通知",
        component: () => import("../views/shouye/infoGonggao/info5.vue"),
      },
      {
        path: "/dn5",
        name: "许峰副校长出席民盟河海大学委员会第六次代表大会",
        component: () => import("../views/shouye/dongtaiNews/d5.vue"),
      },
      {
        path: "/r1",
        name: "雍斌教授在《Nature Communications》上发表研究成果",
        component: () => import("../views/shouye/researchDongtai/r1.vue"),
      },
      {
        path: "/r2",
        name: "王卫光教授团队在国际顶级期刊Global Change Biology发表气候变化生态水文响应新成果",
        component: () => import("../views/shouye/researchDongtai/r2.vue"),
      },
      {
        path: "/r3",
        name: "国家重点研发计划项目“长江水资源开发保护战略与关键技术研究”高质量通过绩效评价",
        component: () => import("../views/shouye/researchDongtai/r3.vue"),
      },
      {
        path: "/r4",
        name: "王卫光教授团队在遥感领域顶级期刊《Remote Sensing of Environment》发表蒸散发估算新成果",
        component: () => import("../views/shouye/researchDongtai/r4.vue"),
      },
      {
        path: "/r5",
        name: "国家重点研发计划课题“变化环境下流域水文气象极端事件演变规律及超标准洪水致灾机理”顺利通过综合绩效评价",
        component: () => import("../views/shouye/researchDongtai/r5.vue"),
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
});

export default router;
